import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const createWarehouse = createAsyncThunk("warehouse/createWarehouse", async (data, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.post("warehouse", data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const initialState = {
	isLoading: false,
	isError: false,
	error: null,
	data: null,
	message: null,
};

const CreateWarehouseSlice = createSlice({
	name: "CreateWarehouseSlice",
	initialState,
	reducers: {
		resetCreateWarehouseState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
			state.message = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(createWarehouse.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.message = null;
		});

		builder.addCase(createWarehouse.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload.data;
			state.message = action.payload.message || null;
		});

		builder.addCase(createWarehouse.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
			state.message = action.payload?.message || null;
		});
	},
});

export const { resetCreateWarehouseState } = CreateWarehouseSlice.actions;
export default CreateWarehouseSlice.reducer;
